module.exports = __webpack_public_path__ + "static/media/HB4.749dbf84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/HB/HB4.png
// module id = 279
// module chunks = 0